import { clsx } from 'clsx';
import type { ReactNode } from 'react';
import styles from './ui.module.css';

/**
 * Название карточки со значком состояния справа.
 *
 * Пару «заголовок плюс StatusBadge в одном ряду» три экрана подряд собрали
 * каждый по-своему — вкуишным Flex с Headline внутри. Здесь она одна, и
 * заодно решена та беда, ради которой раньше держали инлайновый wordBreak:
 * имя одним длинным словом переносится, а не обрезается краем карточки.
 *
 * `size="s"` — подпись поля, а не название вещи: так в макете набрана шапка
 * карточки различий. Пятнадцатым кеглем «Характер, ценности и моральные
 * отклонения» занимал две строки и спорил с самим значением поля.
 *
 * `size="l"` — имя в карточке персонажа у администрации: крупные данные,
 * 22-м кеглем, как в макете. `Heading` сюда не годится гарнитурой и
 * насыщенностью: он набран тонким Unbounded, а в макете это жирный Manrope,
 * как у всех названий карточек.
 */
export function CardHeading({
  children,
  badge,
  badgeAt = 'edge',
  trailing,
  size = 'm',
}: {
  children: ReactNode;
  badge?: ReactNode;
  badgeAt?: 'edge' | 'title';
  /**
   * Хвост у правого края — отдельно от бейджа. Нужен там, где у строки два
   * разных знака: статус версии стоит вплотную к её номеру, а отметка
   * «опубликована» уезжает вправо. Одним слотом это не выразить.
   */
  trailing?: ReactNode;
  size?: 's' | 'm' | 'l';
}) {
  return (
    <div
      className={clsx(styles.cardHeading, ROW[size], badgeAt === 'title' && styles.cardHeadingHug)}
    >
      <span className={clsx(styles.cardHeadingText, TEXT[size])}>{children}</span>
      {badge}
      {trailing === undefined ? null : (
        <span className={styles.cardHeadingTrailing}>{trailing}</span>
      )}
    </div>
  );
}

const ROW = { s: styles.cardHeadingSmallRow, m: '', l: styles.cardHeadingLargeRow };

const TEXT = { s: styles.cardHeadingSmall, m: '', l: styles.cardHeadingLarge };
